import { webApi } from 'src/services/api/config'
import { Notice } from './notices.types'

/**
 * Fetches all notices
 */
export const getNotices = async (): Promise<Notice[]> => {
  const response = await webApi.get('api/site/news/careers')
  return response.data
}

/**
 * Fetches a single notice by id
 */
export const getNoticeById = async (id: string): Promise<Notice> => {
  const response = await webApi.get(`api/site/news/${id}`)
  return response.data
}
